export const LanguageTableHeaders = ["picture", "language", "modify", "delete"];
